import { Card, message } from "antd";
import React, { useEffect, useState } from "react";

import { FaFilePowerpoint } from "react-icons/fa";
import Models from "../Models";
import { api } from "../../../services/api";
import { theme } from "antd";
import { useParams } from "react-router-dom";

const { useToken } = theme;

const Ratings = () => {
  const { token } = useToken();

  const data = [
    {
      icon: <FaFilePowerpoint size={20} color={token.colorPrimary} />,
      title: "Avaliações:",
      steps: "Porcentagem de acertos ",
      type: <span style={{ marginLeft: 10 }}>Nota</span>,
      modelTitle: "Módulo:",
      description: "M3 | Livro-Apostila do Módulo 6 Filtros do Método LCB",
    },
    {
      icon: <FaFilePowerpoint size={20} color={token.colorPrimary} />,
      title: "Avaliações",
      steps: "Porcentagem de acertos ",
      type: <span style={{ marginLeft: 10 }}>Nota</span>,
      modelTitle: "Módulo:",
      description: "M3 | Livro-Apostila do Módulo 6 Filtros do Método LCB",
      // info: "pdf",
    },
  ];

  return (
    <section>
      <Card style={{ padding: 16, backgroundColor: "#FFF", marginTop: 20 }}>
        <h2 style={{ fontSize: "font-size: calc(1.5rem + 0.3vw)" }}>
          Avaliações e nota
        </h2>
        {data.map((el, i) => {
          return (
            <div style={{ padding: "0 15px" }} key={`${el.title}-${i}`}>
              <Models
                icon={el.icon}
                title={el.title}
                modelTitle={el.modelTitle}
                description={el.description}
                info={el.info}
                steps={el.steps}
                type={el.type}
              />
            </div>
          );
        })}
      </Card>
    </section>
  );
};
export default Ratings;
